import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

const styles = theme => ({
  pageTitle: {
    color: theme.palette.secondary.text,
    fontSize: '2rem',
    fontWeight: '600',
    lineHeight: '2.25rem',
    marginTop: '-2.125rem',
    marginBottom: '2rem',
  },
});
const PageTitle = props => (
  <h3 className={`${props.classes.pageTitle} ${props.className}`}>{props.children}</h3>
);
PageTitle.propTypes = {
  children: PropTypes.shape({}).isRequired,
  classes: PropTypes.element.isRequired,
  className: PropTypes.string,
};
PageTitle.defaultProps = {
  className: '',
};
export default withStyles(styles)(PageTitle);

export const LoadingTitle = () => (
  <section className="form-edit-inline--wrapper page-title">
    <div className="loading-dots">Loading</div>
  </section>
);

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '15px',
  },
}));

export const EditableTitle = (props) => {
  const classes = useStyles();
  return (
    <Tooltip arrow title={props.value} classes={classes}>
      <span className={classNames(props.textClass)}>
        {props.value}
      </span>
    </Tooltip>
  );
};


EditableTitle.propTypes = {
  textClass: PropTypes.string,
  value: PropTypes.string.isRequired,
};

EditableTitle.defaultProps = {
  textClass: '',
};
